import * as React from 'react';
import { Timeline } from 'primereact/timeline';
import { classNames } from 'primereact/utils';
import Note from '../ui/Note';
import { GroupServiceGetResponse } from '../../services/api';
import { TimelineEvent } from '../../store/group';

export default function ActivityTimeline({ group, history }: { group: GroupServiceGetResponse, history: TimelineEvent[] }) {
  function markerContent(item: TimelineEvent) {
    return (
      <div className="flex flex-col gap-1 mb-4">
        <Note title={markerTitle(item)} createdBy={item.createdBy} createdDate={item.createdDate} content={item.notes} files={item.documents} />
      </div>
    );
  }

  function markerTitle(item: TimelineEvent) {
    switch (true) {
      case (item.type === 'TIER2' && item.status === 'Requested'):
        return 'Tier 2 relief requested';
      case (item.type === 'TIER2' && item.status === 'Declined'):
        return 'Tier 2 relief declined';
      case (item.type === 'TIER2' && item.status === 'Completed'):
        return 'Tier 2 updated by Actuarial';
      case (item.type === 'HIGH_RISK' && item.status === 'Applied'):
        return 'High risk locked';
      case (item.type === 'HIGH_RISK' && item.status === 'ReviewRequested'):
        return 'Request to remove High risk status';
      case (item.type === 'HIGH_RISK' && item.status === 'Removed'):
        return 'High risk unlocked';
      case (item.type === 'RERATE' && item.status === 'Completed'):
        return 'Rerate updated by Actuarial';
      case (item.type === 'RERATE' && item.status === 'Requested'):
        return 'Rerate requested';
      default:
        return item.title;
    }
  }

  function customMarker(item: TimelineEvent) {

    function getMarkerStyle(): string {
      switch (item.status) {
        case 'Applied':
        case 'danger':
        case 'Declined':
        case 'TurnedOff':
          return 'bg-faded-red border-warning-red';
        case 'warning':
        case 'Requested':
        case 'ReviewRequested':
          return 'bg-faded-yellow border-warning-yellow';
        case 'Completed':
        case 'success':
        case 'Removed':
        case 'TurnedOn':
          return 'bg-faded-green border-accent-green';
        case 'info':
        default:
          return 'bg-faded-blue border-allstate-blue';
      }
    }

    return (
      <div className={classNames("w-6 h-6 border rounded-full", getMarkerStyle())}></div>
    );
  }

  return (
    <section className="grid gap-4">
      <div className="text-lg font-bold">Activity timeline</div>
      <Timeline value={history} marker={customMarker} content={markerContent} align="left" />
    </section>
  )
}